(($) => {


	$(document).ready( () => {

		if($("#pie").length >= 1) initPie();
		if($(".contact--maps-container").length >= 1) initMaps();
		if($(".careers--our-values").length >= 1) initCareersValuesMobile();

		applyInlinePopup();
		applyAjaxPopup();
		
		$('body').on( 'av_resize_finished', () => {
			setTimeout( () => {
				applyInlinePopup();
				applyAjaxPopup();
			}, 150);
		});

		let burger_wrap = $('.av-burger-menu-main a');

		burger_wrap.on('avia_burger_list_created', () => {

			let socialLinks = $(".footer-section ul.ep-social-bookmarks").clone();

			setTimeout(() => {
				$("#av-burger-menu-ul").append("<li class='burger-social-icons'></li>");
				$("#av-burger-menu-ul .burger-social-icons").append(socialLinks);
			}, 300);
			 
		});

		$('.facetwp-template').addClass('posts-grid columns is-multiline is-mobile is-variable is-3');

		
	});

	if($("#pie-slider-mobile").length >= 1) {

		$("#pie-slider-mobile").flickity({
			pageDots: false,
			groupCells: 1,
		});

		//$("#pie-slider-mobile").flickity('resize');

	}
	
	const applyInlinePopup = () => {
		
		$('a[href*="inline"], [data-popup]').on('click', (e) => {
			e.preventDefault();
			
			val = $(this).attr('href').split('?');
			
			$.magnificPopup.open({
				items: {
					src: '#'+val[0]
				},
				type: 'inline',
				showCloseBtn: true,
				mainClass: 'avia-popup mfp-zoom-in',
				tLoading: '',
				tClose: ''
			});
			
		});
	}
	
	const applyAjaxPopup = () => {
		$('a[href*="ajax=true"]').magnificPopup({
			type: 'ajax',
			showCloseBtn: true,
			mainClass: 'avia-popup mfp-zoom-in',
			tLoading: '',
			tClose: ''
		});
		
	}

	const initCareersValuesMobile = () => {

		let careerBlocks = $(".careers--value-block");
		let careerBlocksMobile = $(".our-values-slider-mobile");

		careerBlocks.each( (key, value) => {
			let careerBlockContent = $(value).find(".flex-column-inner").prop('outerHTML');

			careerBlocksMobile.append(`<div class="careers-values-item">${careerBlockContent}</div>`);
		});

		careerBlocksMobile.flickity({
			pageDots: false,
			groupCells: 1,
			wrapAround: false,
			freeScroll: false,
		});
	};

	const initPie = () => {
		
		let pie = $("#pie");
		let pieTexts = $("#pie_texts");
		let pieContentChild = $("#pie_content > div");

		pieContentChild.each( (key, value) => {
			let pieItemTitle = $(value).find("h4").text();
			let pieItemIcon = $(value).find(".av-icon-char").prop('outerHTML');

			pieTexts.append(`<div class="pie_text" data-target="pie-${key+1}">${pieItemIcon}${pieItemTitle}</div>`);
		});

		pie.on("click", "[data-target]", (e) => {
			
			pie.find("[data-content]").removeClass("active");

			let target = e.target.dataset.target;

			pie.attr("data-current", target);
			
			pie.trigger("change");

		});

		pie.on("change", () => {

			let current = pie.attr("data-current");

			pie.find(`[data-content='${current}']`).addClass("active");

		});

		
	};

	const initMaps = () => {
		let mapContainer = $(".contact--maps-container");
		let buttons = mapContainer.find(".avia-buttonrow-wrap");

		buttons.on('click', '.avia-button:nth-child(1)', (e) => {
			e.preventDefault();
			mapContainer.removeClass('second-map-active');
		});

		buttons.on('click', '.avia-button:nth-child(2)', (e) => {
			e.preventDefault();
			mapContainer.addClass('second-map-active');
		});

	};
	
})(jQuery);